import React from 'react';
import styled from 'styled-components';
import Kaja from './Kaja';
import Kaffka from './Kaffka';


/** Every Kaffkas width is multiplied by 0.4, because her SVG is a rectangle
  with 5:2 ratio, so to styled her easier it's better to calc her width rather then guess.
  Same situation with Kajas SVG but for her the rectangle has ratio 2:1,
  so I multiply her height by 0,5.

  z-index is there so the SVGs are over the circle decorations.
 */
const StyledKaffka = styled(Kaffka)`
  height: 300px;
  width: calc(300px * 0.4);
  position: absolute;
  left: 20px;
  bottom: -25px;
  z-index: 2;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 450px;
    width: calc(450px * 0.4);
    left: 0;
    bottom: -75px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    left: -10px;
    height: 500px;
    width: calc(500px * 0.4);
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.large}){
    left: 0;
    height: 600px;
    width: calc(600px * 0.4);
  }
`;

const StyledKaja = styled(Kaja)`
  height: 300px;
  width: calc(300px * 0.5);
  position: absolute;
  right: 20px;
  bottom: -25px;
  z-index: 2;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 450px;
    width: calc(450px * 0.5);  
    right: 65px;
    bottom: -40px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    height: 500px;
    width: calc(500px * 0.5);
    right: 60px;
    bottom: -75px;    
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.large}){
    right: 0;
    height: 600px;
    width: calc(600px * 0.5);
  }
`;

const PortfolioFooter = () => (
  <>
    <StyledKaffka />
    <StyledKaja />
  </>
);

export default PortfolioFooter;
